import React from 'react';
import MenuItem from './MenuItem';
import { venueSellsOnline } from '../../utils/orderTypes';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const MenuGrid = ({
  restaurant,
  categories,
  groupedItems,
  defaultImg,
  onSelectItem,
  activeSubCategory,
  hasHigherCategories = true,
  progressByProduct = {},
}) => {
  const { language } = useDataContext();

  const getHigherCategoryName = (higherCategoryId) => {
    return categories.find((cat) => cat._id === higherCategoryId)?.Category || '';
  };

  const getHigherCategoryImage = (higherCategoryId) => {
    return categories.find((cat) => cat._id === higherCategoryId)?.CoverImage || '';
  };

  const isNewHigherCategory = (index, currentHigherCategoryId) => {
    if (!hasHigherCategories) return false;
    if (index === 0) return true;
    return groupedItems[index - 1]?.higherCategoryId !== currentHigherCategoryId;
  };

  if (groupedItems.length === 0) {
    return (
      <div className="mt-6 text-center py-8">
        <p className="text-gray-500">{translations[language]?.menu_grid_items_unavailable}.</p>
      </div>
    );
  }

  return (
    <div className="space-y-8 py-4">
      {groupedItems.map((group, index) => (
        <section
          key={`${group.higherCategoryId}_${group.category}`}
          id={`${group.higherCategoryId}_${group.category}`}
          data-category={group.category}
          className="menu-section space-y-4"
        >
          {isNewHigherCategory(index, group.higherCategoryId) &&
            hasHigherCategories &&
            getHigherCategoryImage(group.higherCategoryId) && (
              <img
                src={getHigherCategoryImage(group.higherCategoryId)}
                alt={getHigherCategoryName(group.higherCategoryId)}
                loading="lazy"
                className="w-full h-64 sm:h-96 object-cover align-top rounded-[10px] sm:rounded-[20px]"
                onError={(e) => {
                  e.target.hidden = true;
                }}
              />
            )}

          {isNewHigherCategory(index, group.higherCategoryId) && hasHigherCategories && (
            <div className="mb-2 pb-1 inline-block border-b-2 border-primary">
              <h1 className="text-lg sm:text-xl font-bold text-primary">
                {getHigherCategoryName(group.higherCategoryId)}
              </h1>
            </div>
          )}

          <div>
            <h2
              className={`text-base sm:text-lg font-bold ${
                activeSubCategory === `${group.higherCategoryId}_${group.category}`
                  ? 'text-primary'
                  : 'text-gray-800'
              }`}
            >
              {group.category}
            </h2>
            {group.menu?.[0]?.categorydesc && (
              <p className="text-gray-500 text-sm sm:text-base whitespace-pre-wrap">
                {group.menu[0].categorydesc}
              </p>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
            {group.menu.map((item) => (
              <MenuItem
                key={item._id}
                item={item}
                defaultImg={defaultImg || restaurant?.MenuPlaceholder}
                onItemSelectionModalOpen={() => onSelectItem(item)}
                isMenuBuyable={restaurant.isMenuBuyable && !restaurant.orderingPaused}
                isDineIn={restaurant.isdinein}
                isTakeOut={restaurant.istakeout}
                canOrder={venueSellsOnline(restaurant)}
                menuPlaceholder={restaurant.MenuPlaceholder || ''}
                currency={restaurant?.currency?.code || 'DKK'}
                progress={progressByProduct[item._id]}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default MenuGrid;
